<template>
  <c-row>
    <c-col col="5">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Add Bank Account</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control" v-model="bank.name" placeholder="ex: Bank Mandiri" v-bind:class="{'has-error': errors.name}"/>
          </div>
          <div class="form-group">
            <label>Pemilik Rekening</label>
            <input type="text" class="form-control" v-model="bank.owner_name" placeholder="ex: Asm" v-bind:class="{'has-error': errors.owner_name}"/>
          </div>
          <div class="form-group">
            <label>Cabang</label>
            <input
              type="text"
              class="form-control"
              v-model="bank.branch"
              placeholder="ex: Cabang Jakarta"
              v-bind:class="{'has-error': errors.branch}"
            />
          </div>
          <div class="form-group">
            <label>Nomor Rekening</label>
            <input type="text" class="form-control" v-model="bank.number" placeholder="ex: 123456789" v-bind:class="{'has-error': errors.number}"/>
          </div>
        </c-card-body>
        <c-card-footer>
          <sur-button :object="bank" @onSave="save" @onUpdate="update" @onReset="reset"/>
        </c-card-footer>
      </c-card>
    </c-col>
    <c-col col="7">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Add Bank Accounts</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Name</th>
                  <th>No Rekening</th>
                  <th>Pemilik</th>
                  <th>Cabang</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d,k) in banks.data" :key="k">
                  <td>{{k+1}}</td>
                  <td>{{d.name}}</td>
                  <td>{{d.number}}</td>
                  <td>{{d.owner_name}}</td>
                  <td>{{d.branch}}</td>
                  <td>
                    <action-button :object="d" @doEdit="doEdit" @actionDelete="actionDelete"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from '../../lib/httplib';
import SURButton from '../../components/SURButton'
import ActionButton from '../../components/ActionButton'
export default {
  components: {
    'sur-button': SURButton,
    'action-button': ActionButton,
  },
  data() {
    return {
      bank: {},
      banks: [],
      errors: []
    };
  },
  created() {
    const query = this.$route.query;
    if (query.id) {
      this.getBank(query.id);
    }
    this.getBanks();
  },
  methods: {
    getBanks() {
      HTTPAUTH.get("/api/v1/bank-account").then(res => {
        this.banks = res.data;
      }).catch(eres => {
        this.$toasted.error(eres.response.data.user_message).goAway();
      })
    },
    getBank(id) {
      HTTPAUTH.get("/api/v1/bank-account/" + id).then(res => {
        this.bank = res.data.data;
      }).catch(eres => {
        this.$toasted.error(eres.response.data.user_message).goAway();
      })
    },
    update() {
      HTTPAUTH.put("/api/v1/bank-account/" + this.bank.id, this.bank).then(res => {
        this.bank = {};
        this.getBanks();
        this.$router.push({query: {id: ""}})
      }).catch(eres => {
        if (eres.response.data.message) {
          this.$toasted.error(eres.response.data.message).goAway();
          this.errors = eres.response.data.errors;
          return;
        }
        this.$toasted.error(eres.response.data.user_message).goAway();
      })
    },
    save() {
      HTTPAUTH.post("/api/v1/bank-account", this.bank).then(res => {
        this.bank = {};
        this.getBanks();
      }).catch(eres => {
        if (eres.response.data.message) {
          this.$toasted.error(eres.response.data.message).goAway();
          this.errors = eres.response.data.errors;
          return;
        }
        this.$toasted.error(eres.response.data.user_message).goAway();
      })
    },
    reset() {
      this.bank = {};
    },
    actionDelete(o) {
      HTTPAUTH.delete("/api/v1/bank-account/" + o.id).then(res => {
        this.bank = {};
        this.getBanks();
      }).catch(eres => {
        if (eres.response.data.message) {
          this.$toasted.error(eres.response.data.message).goAway();
          this.errors = eres.response.data.errors;
          return;
        }
        this.$toasted.error(eres.response.data.user_message).goAway();
      })
    },
    doEdit(object) {
      this.$router.push({query: {id: object.id}})
      this.bank = object;
    }
  }
};
</script>